import React from 'react'

export function FeedbackTab({ onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label="Send feedback"
      style={styles.tab}
      onMouseEnter={(e) => { e.currentTarget.style.opacity = '1' }}
      onMouseLeave={(e) => { e.currentTarget.style.opacity = '0.85' }}
    >
      Feedback
    </button>
  )
}

const styles = {
  tab: {
    position: 'fixed',
    right: 0,
    top: '50%',
    transform: 'translateY(-50%)',
    writingMode: 'vertical-rl',
    rotate: '180deg',
    background: 'var(--accent-brand)',
    color: '#fff',
    border: 'none',
    borderRadius: '0 var(--radius-md) var(--radius-md) 0',
    padding: '12px var(--space-2)',
    fontSize: '12px',
    fontWeight: 600,
    fontFamily: 'inherit',
    letterSpacing: '0.5px',
    cursor: 'pointer',
    opacity: 0.85,
    zIndex: 'var(--z-sticky)',
    transition: 'opacity var(--duration-fast) ease',
  },
}
